import { render, staticRenderFns } from "./ShopCard.vue?vue&type=template&id=52d389e7&scoped=true&"
import script from "./ShopCard.vue?vue&type=script&lang=js&"
export * from "./ShopCard.vue?vue&type=script&lang=js&"
import style0 from "./ShopCard.vue?vue&type=style&index=0&id=52d389e7&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d389e7",
  null
  
)

export default component.exports